import React, { useEffect, useContext } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import GetToken from "./GetToken";
import { AppContext } from "./context/AppContext";

const VerifyToken = () => {
	const navigate = useNavigate();
	const { base_url ,fetchMenuPermissions } = useContext(AppContext);
	const lastURL = document.referrer;

	useEffect(() => {
		const loginToken = GetToken();
		if (loginToken) {
			navigate("/dashboard", { replace: true });
			return;
		}

		const email = new URLSearchParams(window.location.search).get("token");
		const decodedEmail = email ? atob(email) : null;
		if (!decodedEmail) {
			window.location.href = lastURL;
			return;
		}

		const auth = new FormData();
		auth.append("email", decodedEmail);

		axios.post(`${base_url}authentication-email`, auth)
			.then((res) => {
				if (res.data.status === true) {
					localStorage.setItem("activeusertoken", res.data.token);
					localStorage.setItem("username", res.data.username);
					localStorage.setItem("avatar", res.data.avatar);
					localStorage.setItem("email", res.data.email);
					fetchMenuPermissions();
					setTimeout(() => {
						navigate("/dashboard", { replace: true });
					}, 500);
				} else {
					Swal.fire({
						icon: "error",
						title: "Login Failed...",
						text: res.data.message,
					});
					window.location.href = lastURL;
					return;
				}
			})
			.catch(() => {
				Swal.fire({
					icon: "error",
					title: "Oops...",
					text: "An error occurred during login. Please try again.",
				});
				window.location.href = lastURL;
				return;
			});
	}, []);

	return null;
};

export default VerifyToken;
